document.addEventListener('DOMContentLoaded', () => {
  // Early exit if mobile
  if (window.innerWidth <= 768) return;

  const sliderTrack = document.querySelector('.collection-slider-track');
  const prevButton = document.querySelector('.collection-slider-button.prev');
  const nextButton = document.querySelector('.collection-slider-button.next');
  const cards = document.querySelectorAll('.collection-card');

  // NULL CHECK - Exit if elements don't exist
  if (!sliderTrack || !prevButton || !nextButton || cards.length === 0) return;

  let currentPosition = 0;
  let cardWidth = 0;
  const gap = 20;

  function calculateDimensions() {
    if (cards.length > 0) {
      const cardStyle = window.getComputedStyle(cards[0]);
      cardWidth = cards[0].offsetWidth +
                 parseInt(cardStyle.marginLeft || 0) +
                 parseInt(cardStyle.marginRight || 0) +
                 gap;
    }
    return {
      visibleCards: Math.floor(sliderTrack.offsetWidth / cardWidth),
      maxPosition: Math.max(0, cards.length - Math.floor(sliderTrack.offsetWidth / cardWidth))
    };
  }

  function updateSlider() {
    const { maxPosition } = calculateDimensions();
    currentPosition = Math.max(0, Math.min(currentPosition, maxPosition));
    sliderTrack.style.transform = `translateX(-${currentPosition * cardWidth}px)`;

    // Update button states with visual feedback
    prevButton.disabled = currentPosition === 0;
    nextButton.disabled = currentPosition >= maxPosition;

    // Add aria-labels for accessibility
    prevButton.setAttribute('aria-disabled', currentPosition === 0);
    nextButton.setAttribute('aria-disabled', currentPosition >= maxPosition);
  }

  function handlePrev() {
    const { visibleCards } = calculateDimensions();
    currentPosition = Math.max(0, currentPosition - visibleCards);
    updateSlider();
  }

  function handleNext() {
    const { visibleCards, maxPosition } = calculateDimensions();
    currentPosition = Math.min(maxPosition, currentPosition + visibleCards);
    updateSlider();
  }

  // Handle resize with debounce
  let resizeTimer;
  function handleResize() {
    if (window.innerWidth <= 768) return;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      updateSlider();
    }, 250);
  }

  // Keyboard navigation
  function handleKeyboard(e) {
    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      handlePrev();
    } else if (e.key === 'ArrowRight') {
      e.preventDefault();
      handleNext();
    }
  }

  // Initialize
  updateSlider();
  prevButton.addEventListener('click', handlePrev);
  nextButton.addEventListener('click', handleNext);
  window.addEventListener('resize', handleResize);

  // Add keyboard navigation when slider is focused
  sliderTrack.addEventListener('keydown', handleKeyboard);
  sliderTrack.setAttribute('tabindex', '0');
  sliderTrack.setAttribute('role', 'region');
  sliderTrack.setAttribute('aria-label', 'Collection slider');

  // Cleanup on page unload
  window.addEventListener('beforeunload', () => {
    window.removeEventListener('resize', handleResize);
    sliderTrack.removeEventListener('keydown', handleKeyboard);
  });
});
